(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
      this.cardsSize = this.dataset.cardsSize || 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = {
        desktop: 990
      };
    }

    connectedCallback() {
      // For main carousel sections
      if (this.classList.contains('products-carousel--spacing-mobile-')) {
        this.setupTabHandling();
      }
      
      // Initialize swiper if this is a carousel within a tab content
      this.initSwiper();
      this.toggleSwiperHandler();
      window.addEventListener('resize', debounce(this.toggleSwiperHandler.bind(this), 500));
    }

    setupTabHandling() {
      const tabs = this.querySelectorAll('[data-tab]');
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const tabId = tab.dataset.tab;
          this.switchTab(tabId);
        });
      });
    }

    switchTab(tabId) {
      // Remove active class from all panels and reinitialize their swipers
      const panels = this.querySelectorAll('[data-tab-content]');
      panels.forEach(panel => {
        panel.classList.remove('is-active');
        const carousel = panel.querySelector('products-carousel');
        if (carousel && carousel.swiper) {
          carousel.swiper.update();
        }
      });

      // Set the clicked tab's panel as active
      const activePanel = this.querySelector(`[data-tab-content="${tabId}"]`);
      if (activePanel) {
        activePanel.classList.add('is-active');
        // Reinitialize or update swiper when panel becomes visible
        const carousel = activePanel.querySelector('products-carousel');
        if (carousel && carousel.swiper) {
          setTimeout(() => {
            carousel.swiper.update();
            carousel.swiper.scrollbar.update();
          }, 10);
        }
      }

      // Update active tab button
      const tabs = this.querySelectorAll('[data-tab]');
      tabs.forEach(tab => {
        if (tab.dataset.tab === tabId) {
          tab.classList.add('is-active');
        } else {
          tab.classList.remove('is-active');
        }
      });
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.products-carousel__slider');

      const swiperNext = this.querySelector('.products-carousel__control-next');
      const swiperPrev = this.querySelector('.products-carousel__control-prev');

      const sizeCardSettings = {
        default: {
          slidesPerView: 1.2,
          spaceBetween: 32,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 2.75,
              spaceBetween: 48,
            },
          },
        },
        large: {
          slidesPerView: 1.1,
          spaceBetween: 24,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 3.2,
              spaceBetween: 24,
            },
          },
        },
      };


      if (!swiperContainer) return;

      const mainSettings = {
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev,
        },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        speed: 300,
        ...sizeCardSettings[this.cardsSize]
      };

      this.swiper = new Swiper(swiperContainer, mainSettings);
    }

    toggleSwiperHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSwiper(window.innerWidth >= this.breakpoints.desktop);
      } catch(e) {}
    }

    toggleSwiper(destroy) {
      if (destroy) {
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }
      } else {
        this.initSwiper();
      }
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
